// src/features/home/components/Slideshow.jsx
import React from 'react';
import { useSlideshow } from '../hooks/useSlideshow';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import Loading from "../../../layouts/Loading";


const Slideshow = () => {


    const { slides, loading } = useSlideshow();
    const [slideModal, setSlideModal] = React.useState([]);

    if (loading) return <Loading />;


    return (
        <React.Fragment>
            <div className="modal fade bottom-sheet mt-5  " id="slideDescription" tabIndex="-1"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-bottom mobile-size-option overflow-y-auto vh-100 mt-5">
                    <div className="modal-content">
                        <div className="modal-header rtl">

                            <h1 className="modal-title fs-5 fw-bold text-center" id="exampleModalLabel">
                                <img src={slideModal.image} alt={slideModal.name} className='w-100 mb-4'/>
                                {slideModal.name}
                            </h1>

                        </div>
                        <div className="modal-body text-justify">
                            <p dangerouslySetInnerHTML={{__html: slideModal.description}}></p>
                            {  slideModal?.link &&
                                <div className='text-start' >
                                    <a href={slideModal.link}>
                                        اطلاعات بیشتر
                                    </a>
                                </div>
                            }
                        </div>
                        <div className="modal-footer ">



                                <button type="button" className="btn btn-secondary text-small-1"
                                        data-bs-dismiss="modal"

                                >
                                    بستن
                                </button>



                        </div>

                    </div>
                </div>
            </div>
            <div className="container my-1 slideshow">
                <Swiper
                    modules={[Autoplay, Pagination]}
                    autoplay={{delay: 3000}}
                    pagination={{clickable: true}}
                    loop
                    spaceBetween={10}
                    slidesPerView={1}
                >
                    {slides.map(slide => (
                        <SwiperSlide key={slide.id}>
                            <div onClick={() => {
                                if (slide.link.length > 2 && slide.description.length < 5) {
                                    window.location.assign(slide.link)
                                }
                                setSlideModal(slide)

                            }}
                                 data-bs-toggle={slide.description.length > 5 ? "modal" : ''}
                                 data-bs-target={slide.description.length > 5 ? "#slideDescription" : ''}
                            >
                            <img
                                    src={slide.image}
                                    alt={slide.name || 'slide'}
                                    className="img-fluid w-100 rounded"
                                    style={{maxHeight: '350px', objectFit: 'cover'}}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </React.Fragment>

    );
};

export default Slideshow;
